import { useEffect, useState } from "react";
import "./App.css";
import { ListaPedido } from "./componentes/ListaPedido/ListaPedido";
import {
  Route,
  Routes,
} from "react-router-dom";

import { DetalleAlternativo } from "./componentes/DiseñoAlternativoDetalle/DetalleAlternativo";
import RegistroGuests from "./componentes/RegistroUsuario/RegistroGuests";
import FormularioMesa from "./componentes/FormularioMesa/FormularioMesa";
import FormularioDomicilio from "./componentes/FormularioDomicilio/FormularioDomicilio";
import AgregarTarjeta from "./componentes/AgregarTarjeta/AgregarTarjeta";
import ListaTiendas from "./componentes/ListaTiendas/ListaTiendas";
import { DetallePago } from "./componentes/DetallePago/DetallePago";
import { ResumenPedido } from "./componentes/ListaOrdenes/ResumenPedido";
import { SeguimientoPedido } from "./componentes/SeguimientoPedido/SeguimientoPedido";
///////
import { NewHome } from "./componentes/Home/NewHome";
import { Menu3 } from "./componentes/menu/Menu3";
import { MenuLocal } from "./componentes/menu/MenuLocal";
import { OrderSummary } from "./componentes/ListaOrdenes/OrderSummary";
import { Seguimiento } from "./componentes/ListaOrdenes/Seguimiento";
import { apiGet } from './utils/api';
import { configShop } from './states/configShop';
import AddressAdd from "./componentes/Address/AddressAdd";
import { Sedes } from "./componentes/Home/sedes";
import { MenuShop } from "./componentes/menu/MenuShop";
import { EncuestaCorreo, EncuestaBaja } from "./componentes/nps/EncuestaCorreo";



function useMeta(property, content) {
  useEffect(() => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  }, [property, content]);
}

function AppMenuDigital() {
  const { setDataConfig } = configShop();
  // para formatear el precio. para darle formato a los precios.
  const codigoPais = "es-CO";
  const codigoCurrency = "COP";
  const [propiedadesCompany, setPropiedadesCompany] = useState([]);
  const {
    color_hover,
    color_botton,
  } = propiedadesCompany;
  useEffect(() => {
    (async function () {
      const res = await apiGet('/home');
      var mensajeExito = res.success;
      if (mensajeExito === "success") {
        setDataConfig(res.properties);
        setPropiedadesCompany(res.properties);
        setListaTiendas();
      }
    })();
    // }
  }, []);

  useEffect(() => {
    // Cambiar el título dinámicamente cuando se carga esta página
    document.title = propiedadesCompany.company_name;
    const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = propiedadesCompany.company_logo; // Ruta del favicon para esta página
    document.head.appendChild(link);
    ////
    // Buscar si ya existe
    let link2 =
      document.querySelector("link[rel='apple-touch-icon']") ||
      document.createElement("link");
    link2.rel = "apple-touch-icon";
    link2.href = propiedadesCompany.company_logo; // Ruta del favicon para esta página
    link2.sizes = "180x180";
    document.head.appendChild(link2);
    ////
    const setMeta = (property, content) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    setMeta("og:title", propiedadesCompany.company_name);
    setMeta("og:description", propiedadesCompany.description_home);
    setMeta("og:image", propiedadesCompany.company_logo);
    setMeta("og:url", window.location.href);
    setMeta("og:image", propiedadesCompany.company_logo);

  }, [propiedadesCompany]); // Este efecto solo se ejecuta una vez, cuando se monta el componente


  const [listaTiendas, setListaTiendas] = useState([]);

  return (
    <Routes>
      <Route path="/" element={<NewHome />} />
      <Route path="/menu" element={<Menu3 />} />
      <Route path="/menu-local" element={<MenuLocal />} />
      <Route path="/menu-shop/:shop" element={<MenuShop />} />
      <Route
        path="/detail/:idDetalleAlternativo"
        element={
          <DetalleAlternativo
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
          />
        }
      />
      <Route
        path="/shoppingCart/"
        element={
          <ListaPedido
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
            color_botton={color_botton}
            color_hover={color_hover}
            propiedadesCompany={propiedadesCompany}
          />
        }
      />
      <Route
        path="/AddressAdd/"
        element={<AddressAdd />}
      />
      <Route
        path="/RegistroGuests/"
        element={<RegistroGuests propiedadesCompany={propiedadesCompany} />}
      />
      <Route
        path="/detallePago/"
        element={
          <DetallePago
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
            propiedadesCompany={propiedadesCompany}
          />
        }
      />
      <Route
        path="/resumenPedido/:idDetalle"
        element={
          <ResumenPedido
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
            propiedadesCompany={propiedadesCompany}
          />
        }
      />
      <Route
        path="/sedes/"
        element={
          <Sedes
            propiedadesCompany={propiedadesCompany}
            listaTiendas={listaTiendas}
          />
        }
      />
      {/*///////// */}






      <Route
        path="/FormularioMesa/"
        element={
          <FormularioMesa
            propiedadesCompany={propiedadesCompany}
            listaTiendas={listaTiendas}
          />
        }
      />
      <Route
        path="/FormularioDomicilio/"
        element={
          <FormularioDomicilio
            propiedadesCompany={propiedadesCompany}
          />
        }
      />
      <Route
        path="/detailAlternativo/:idDetalleAlternativo"
        element={
          <DetalleAlternativo
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
          />
        }
      />
      <Route
        path="/home"
        element={
          <NewHome codigoCurrency={codigoCurrency} codigoPais={codigoPais} />
        }
      />
      <Route
        path="/detail-order/:idDetalle"
        element={
          <ResumenPedido
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
            propiedadesCompany={propiedadesCompany}
          />
        }
      />
      <Route
        path="/seguimiento/:idDetalle"
        element={
           <ResumenPedido
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
            propiedadesCompany={propiedadesCompany}
          />
        }
      />

      {/* PLZ-234: encuesta NPS que llega por correo */}
      <Route path="/encuesta/:enlace" element={<EncuestaCorreo />} />
      <Route path="/encuesta/:enlace/baja" element={<EncuestaBaja />} />

      <Route
        path="/OrderSummary/:idDetalle"
        element={
          <OrderSummary
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
            propiedadesCompany={propiedadesCompany}
          />
        }
      />
      <Route
        path="/agregarTarjeta/"
        element={
          <AgregarTarjeta
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
            propiedadesCompany={propiedadesCompany}
          />
        }
      />
      <Route
        path="/ListaTiendas/"
        element={<ListaTiendas propiedadesCompany={propiedadesCompany} />}
      />
      <Route
        path="/seguimientoPedido/"
        element={
          <SeguimientoPedido
            propiedadesCompany={propiedadesCompany}
            codigoCurrency={codigoCurrency}
            codigoPais={codigoPais}
          />
        }
      />
    </Routes>
  );
}
export default AppMenuDigital;
